import { requestType } from '~/config/enum.config';
var SERVICE = 'dataimp-service';
var CONTROLLER = 'strategyConfigController';
/**
 * 策略控制器
 */
export default {
    /**
     * 获取支持的策略字段
     */
    getStrategyFields: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getStrategyFields',
        type: requestType.Get,
    },
    /**
     * 创建策略
     */
    createStrategy: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'createStrategy',
        type: requestType.Post,
    },
    /**
     * 修改策略
     */
    updateStrategy: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'updateStrategy',
        type: requestType.Put,
    },
    /**
     * 作废/终止
     */
    updateStrategyStatus: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'updateStrategyStatus',
        type: requestType.Get,
    },
    /**
     * 分页查询策略
     */
    queryStrategyConfigPage: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryStrategyConfigPage',
        type: requestType.Get,
    },
    /**
     * 通过ID获取策略
     */
    getOneById: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getOneById',
        type: requestType.Get,
    },
    /**
     * 通过ID删除策略
     */
    delete: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'delete',
        type: requestType.Delete,
    },
    /**
     * 策略执行记录查看
     */
    queryStrategyConfigDetailData: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryStrategyConfigDetailData',
        type: requestType.Get,
    },
    /**
     * 获取分案管理策略字段
     */
    getLabelNameFields: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getLabelNameFields',
        type: requestType.Get,
    }
};
